import Spinner from "react-bootstrap/Spinner";
import "./Loader.scss";

interface LoaderProps {
  sizeBig?: boolean;
  className?: string;
}

export default function Loader(props: LoaderProps) {
  return (
    <div
      className={
        "container bg-white border-bottom rounded-top rounded-bottom d-flex align-items-center justify-content-center loader-component" +
        (props.sizeBig ? " size-big" : "") +
        " " +
        props.className
      }
    >
      <Spinner animation="border" variant="primary" />
    </div>
  );
}
